import {
    recomputeIndexForOptionsAndUpdate,
    recomputeIndexForOptions,
    updatePickerOptions,
} from '../actions/pickerOptionsActions';
import { updateNavIndex } from '../actions/selectedOptionActions';
import { orchestrator } from 'satcheljs';

orchestrator(recomputeIndexForOptionsAndUpdate, ({ viewState }) => {
    const { options, selectedOption } = viewState;
    recomputeIndexForOptions(viewState);
    updatePickerOptions(viewState, options);
    if (selectedOption?.index) {
        updateNavIndex(viewState, selectedOption.index);
    }
});
